import { render, staticRenderFns } from "./Versions.vue?vue&type=template&id=788c8559&scoped=true&"
import script from "./Versions.vue?vue&type=script&lang=js&"
export * from "./Versions.vue?vue&type=script&lang=js&"
import style0 from "./Versions.vue?vue&type=style&index=0&id=788c8559&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "788c8559",
  null
  
)

export default component.exports